const common = {
  'brand': 'USFans Spreadsheet',
  'nav.home': 'Strona główna',
  'nav.shoppingGuide': 'Poradnik zakupowy',
  'nav.categories': 'Kategorie',
  'nav.guides': 'Poradniki',
  'nav.reviews': 'Opinie',
  'nav.safety': 'Bezpieczeństwo',
  'nav.cta': 'Kup Teraz',
  'common.readMore': 'Czytaj więcej',
  'common.updated': 'Zaktualizowano',
  'common.mainSite': 'Odwiedź stronę główną',
  'common.backHome': 'Wróć na stronę główną',
  'footer.tagline': 'Niezależne centrum zasobów, które pomaga uporządkować zasoby arkuszy USFans, listy produktów, informacje o sprzedawcach i poradniki zakupowe w jednym miejscu.',
  'footer.navTitle': 'Nawigacja',
  'footer.resourcesTitle': 'Zasoby',
  'footer.categories': 'Kategorie',
  'footer.guides': 'Poradniki',
  'footer.reviews': 'Opinie',
  'footer.safety': 'Centrum bezpieczeństwa',
  'footer.disclaimer': 'Ta strona jest niezależnym źródłem informacji. Zawsze weryfikuj niezależnie strony internetowe, sprzedawców, linki, ceny i szczegóły transakcji przed podjęciem jakichkolwiek działań.',
  'footer.rights': 'Wszelkie prawa zastrzeżone.',
  'lang.english': 'English',
  'lang.polish': 'Polski',
  'lang.spanish': 'Español',
  'lang.french': 'Français',
};

export default common;